import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';

import { ReactComponent as IconTimes } from "assets/images/icons/project-icons/times.svg"
import useInlinePageRouter from 'components/__new/general/useInlinePageRouter';
import Maybe from 'components/__new/common/Maybe';
import BankSingleTransfer from './BankSingleTransfer';
import BankBulkTransfer from './bulkTransfer/BankBulkTransfer';
import WideViewModal from 'components/__new/common/WideViewModal';
import BankMultipeTransfer from './multipleTransfer/BankMultipeTransfer';
import MultipleBankTransfersPreview from './multipleTransfer/MultipleBankTransfersPreview';
import { clearBankTransferPreviewItems, saveBankrTansferPreviewItems } from 'store/entities/transfers/action';
import { WorkflowType } from 'utils/workflowType';


const BankTransferType = ({
    isOpen,
    toggleBankTransferType,
    toggleTransferDestination,
    toggleBulkBankReview,
    setTransferType,
    bankTransferTabItems,
    initiateTransfer,
    bankPreviewItems,
    setBankPreviewItems,
    toggleMultipleBankTransferAmount,
    selectedSourceAccount, 
    setSelectedSourceAccount,
    setFees
    }) => {
    const dispatch = useDispatch();
    const { InlineRouterTab, activeTab } = useInlinePageRouter(WorkflowType.TRANSFER_REQUEST);
    const [isWideViewOpen, setIsWideViewOpen] = useState(false);
    const {bankTransferPreviewItems} = useSelector((state) => state.entities.transfers)
    
    const isMultipleTransfer = activeTab === WorkflowType.MULTIPLE_TRANSFER_REQUEST;
    const isBulkTransfer = activeTab === WorkflowType.BULK_TRANSFER;
    
    const closeModal = () => {
        setBankPreviewItems([]);
        dispatch(clearBankTransferPreviewItems())
        toggleBankTransferType();
        toggleTransferDestination();
        setSelectedSourceAccount(null);
    }
    
    const proceedToAmountSetup = () => {
        dispatch(saveBankrTansferPreviewItems(bankPreviewItems))
        toggleBankTransferType();
        toggleMultipleBankTransferAmount();
    }
    
    useEffect(() => {
        if(activeTab !== "multiple" && isWideViewOpen === true) {
            setIsWideViewOpen(false);
            setBankPreviewItems([])
        }
        // eslint-disable-next-line
    }, [activeTab])
    
    useEffect(() => {
        if(isMultipleTransfer && bankTransferPreviewItems?.length > 0 && isWideViewOpen === false) {
            setBankPreviewItems(bankTransferPreviewItems);
            setIsWideViewOpen(true);
        }
        // eslint-disable-next-line
    }, [bankTransferPreviewItems, isWideViewOpen])
    

    return (
        <WideViewModal wideViewControl={isWideViewOpen} size="md" wideViewClassName="w-[70%]" isOpen={isOpen} setIsOpen={() => {}} dialogPanelClassName="h-max-full">
            <div className={`relative ${isWideViewOpen && "flex items-start justify-between"}`}>
                <div className={`${isWideViewOpen ? "w-2/5" : "w-full"}`}>
                
                    <div className='pb-2 mb-2'>
                        <div className="flex items-center justify-between">
                            <div className="text-xl font-bold">
                                To Bank Account
                            </div>
                            
                            <Maybe condition={isWideViewOpen === false}>
                                <div onClick={closeModal} className='w-7 h-7 bg-[#f4f4f4] cursor-pointer rounded-md flex items-center justify-center'>
                                    <IconTimes width={30} />
                                </div>
                            </Maybe>
                        </div>
                        
                        <div className="pt-2">
                            Send money to {isMultipleTransfer ? "2 - 20" : ""} other bank recipients
                        </div>
                    </div>
                    
                    
                    <InlineRouterTab
                        tabMode
                        useFullWidth
                        items={bankTransferTabItems}
                        onTabChange={(activeItem) => setTransferType(activeItem)}
                    />
                    
                    <div className="pt-4">
                        <Maybe condition={activeTab === WorkflowType.TRANSFER_REQUEST}>
                            <BankSingleTransfer
                                toggleTransferDestination={toggleTransferDestination}
                                toggleBankTransferType={toggleBankTransferType}
                                initiateTransfer={initiateTransfer}
                                setFees={setFees}
                                selectedSourceAccount={selectedSourceAccount} setSelectedSourceAccount={setSelectedSourceAccount}
                            />
                        </Maybe>
                        
                        <Maybe condition={activeTab === WorkflowType.MULTIPLE_TRANSFER_REQUEST}>
                            <BankMultipeTransfer 
                                bankPreviewItems={bankPreviewItems}
                                setBankPreviewItems={setBankPreviewItems}
                                isWideViewOpen={isWideViewOpen}
                                setIsWideViewOpen={setIsWideViewOpen}
                                toggleTransferDestination={toggleTransferDestination}
                                toggleBankTransferType={toggleBankTransferType}
                                selectedSourceAccount={selectedSourceAccount} setSelectedSourceAccount={setSelectedSourceAccount}
                            />
                        </Maybe>
                        
                        <Maybe condition={activeTab === WorkflowType.BULK_TRANSFER}>
                            <BankBulkTransfer 
                                toggleTransferDestination={toggleTransferDestination}
                                toggleBankTransferType={toggleBankTransferType}
                                toggleBulkBankReview={toggleBulkBankReview}
                            />
                        </Maybe>
                    </div>
                </div>
                
                <Maybe condition={isWideViewOpen}>
                    <div className='w-3/5 ml-5'>
                        <MultipleBankTransfersPreview
                            isOpen={isWideViewOpen}
                            bankPreviewItems={bankPreviewItems}
                            setBankPreviewItems={setBankPreviewItems}
                            setIsOpen={setIsWideViewOpen}
                        />
                        
                        <div className="rounded-3xl py-1.5 px-3 flex items-center justify-between bg-ep-primary-light-100">
                            <p className="text-ep-gray-500">Recipients</p>
                            <p className="text-ep-gray-600">{bankPreviewItems?.length}</p>
                        </div>
                    </div>
                </Maybe>
            </div>
            
            <Maybe condition={isWideViewOpen === true}>
                <div className="w-full flex items-center justify-end border-t pt-5 mt-5">
                    <button type="button" onClick={closeModal} className="btn btn-transparent-primary mr-3">
                        Cancel
                    </button>
                    
                    <button onClick={proceedToAmountSetup} className="btn btn-ep-primary">
                        Continue
                    </button>
                </div>
            </Maybe>
        </WideViewModal>
    )
}

export default BankTransferType